module.exports = __webpack_public_path__ + "static/media/independent.6a5db112.jpg";